//LMIT-604
import React, { Component } from 'react';
import './css/lessee-page.css';
import UploadLightbox from './upload-lightbox.js';

class DocumentUploadPage extends Component {
	constructor(props){
		super(props);
		var dt = new Date();
		var monthName = window.l10n[window.locale]["lessee.monthnames"][dt.getMonth()];
		var strDate = monthName + " " + dt.getDate() + ", " + dt.getFullYear();
		if (window.locale==='FR'){
			strDate = dt.getDate() + " " + monthName + ", " + dt.getFullYear()
		}
		this.state = {
			strDate,
			lesseeName: "John Smith",
			isActiveUploadLightbox: false,
			dbFields: {},
			ajaxLoadingState : "loading"
		};
		//this.uploadFile = this.uploadFile.bind(this);
		this.showUploadLightbox = this.showUploadLightbox.bind(this);
		this.dismissUploadLightbox = this.dismissUploadLightbox.bind(this);
		//console.log("LesseePage optaToken=" + window.optaToken);
	}


	camelCase(str) {
		var retVal = "";
		for (var i = 0; i < str.length; i++) {
			var c = str.charAt(i).toLowerCase();
			if (i === 0 || str.charAt(i - 1) === " ") c = c.toUpperCase();
			retVal += c;
		}
		retVal = retVal.replace(/bmw/gi, "BMW");
		retVal = retVal.replace(/sci/gi, "SCI");
		return retVal;
	}

	preprocessServerResponse(jsonO) {
		//console.log("Preprocessing %o", jsonO);

		var userOem = jsonO["Key"];
		jsonO = jsonO["Value"] ? jsonO["Value"][0] : {};
		jsonO["useroem"] = this.camelCase(userOem);

		//trim dates
		jsonO["PolicyExpiryDate"] = (""+jsonO["PolicyExpiryDate"]).split("T")[0];

		//trim long strings for userOEM
		if (jsonO["useroem"]==='Vw'){
			jsonO["LossPayee"] = this.camelCase(jsonO["Make"]);
			jsonO["AdditionalInsured"] = this.camelCase(jsonO["Make"]);
		} else {
			jsonO["LossPayee"] = this.camelCase((""+jsonO["LossPayee"]).split(" ")[0]);
			jsonO["AdditionalInsured"] = this.camelCase((""+jsonO["AdditionalInsured"]).split(" ")[0]);
		}
		//normalize names
		var l;
		var names;

		if (typeof jsonO["LesseeName"] ==="undefined") jsonO["LesseeName"] = "";
		jsonO["LesseeName"] = jsonO["LesseeName"].trim();
		if ( jsonO["LesseeName"].match(/,/)){
			names = jsonO["LesseeName"].split(",");
			l = names.length;
			jsonO["FirstName"] = this.camelCase(names[l-1].trim());
			jsonO["LastName"] = this.camelCase(names[0].trim());
		} else if (jsonO["LesseeName"].match(/ /)){
			names = jsonO["LesseeName"].split(" ");
			l = names.length;
			jsonO["FirstName"] = this.camelCase( (names[0]).trim());
			for (var i=1; i<(l-1); i++)
				jsonO["FirstName"] += " " + this.camelCase( names[i].trim());
			jsonO["LastName"] = this.camelCase( names[l-1].trim());
		} else {
			jsonO["FirstName"] = (""+jsonO["LesseeName"]);
			jsonO["LastName"] = "";
		}
		return jsonO;
	}

	getLesseeDetailsFromServer(){
		var t = this;
		var formData = new FormData();
		//console.log("getLesseeDetailsFromServer optaToken=" + window.optaToken);
		formData.append("optatoken", window.optaToken);

		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function () {
			if (this.readyState === 4) {
				if (this.status === 200) {
					if (this.responseText) {
						var responseJson = JSON.parse(this.responseText);
						//console.log("responseJson:", responseJson);
						var dbFields = t.preprocessServerResponse(responseJson);
						t.setState({ dbFields: dbFields, ajaxLoadingState: "" });
					}
				} else {
					//go to login page
					t.setState({ ajaxLoadingState: "" });
					var pathName = "landing-" + window.locale;

					//console.log("this.status='" + this.status + "'");
					//console.log("window.location='" + window.location.href + "'");
					//console.log("window.pathname='" + window.location.pathname + "'");
					//console.log("Token expired. Going to login page: '" + pathName + "'");

					window.optatoken = "";
					window.location.pathname = pathName;
				}
			}
		};

		xhr.open('post', window.AppConfig["url-lesseedetails"], true);
		try {
			this.setState({ ajaxLoadingState: "loading" });
			xhr.send(formData);
		} catch (e) {
			console.log("Failed to get lessee details:" + e);
		}

	}


	componentDidMount() {
		this.getLesseeDetailsFromServer();
	}

	componentWillUnmount() {
	}

	uploadFile(e) {
		console.log("Uploading file event: %o", e);
	}

	showUploadLightbox() {
		//console.log("Lessee SHOW lightbox. isActiveUploadLightbox: " + this.state.isActiveUploadLightbox);
		this.setState({ isActiveUploadLightbox: true });
		window.keepAlive();
	}

	dismissUploadLightbox() {
		//console.log("Lessee DISMISS lightbox.");
		this.setState({ isActiveUploadLightbox: false });
		window.keepAlive();
	}

	nORz(v) {
		if (!v) return true;
		if (v === "1" || v === 1 || v ==="y" || v ==="Y") return false;
		return true;
	}

	getClassForPolicyItem(v){
		/*	
			{ null } 	==>	na
			{ 0, n, N }	==>	no
			{ 1, y, Y }	==>	yes
			{ * } 		==>	na
		*/

		if (v === undefined) return " na ";
		v = v.trim().toLowerCase();
		if (v === 0 || v === "0" || v === "n" ) return " yes ";
		if (v === 1 || v === "1" || v === "y" ) return " no ";

		return " na ";

	}

	isAccountInGoodStanding() {
		if (
			this.nORz(this.state.dbFields["ExpiredIssues"]) &&
			this.nORz(this.state.dbFields["ComprehensiveIssues"]) &&
			this.nORz(this.state.dbFields["TPLIssues"]) &&
			this.nORz(this.state.dbFields["PermToRentOrLeaseEndorsementIssues"]) &&
			this.nORz(this.state.dbFields["AllPerilsIssues"]) &&
			this.nORz(this.state.dbFields["AdditionalInsuredIssues"]) &&
			this.nORz(this.state.dbFields["CollsionIssues"]) &&
			this.nORz(this.state.dbFields["CancelledIssues"]) &&
			this.nORz(this.state.dbFields["LossPayeeIssues"])
		) return true;
		return false;
	}

	isPolicyInformationAvailable()
	{
		var v = this.state.dbFields["InsuranceCompanyName"];
		if (!v || v === "") return false;
		return true;
	}

	getClassForAccountInGoodStanding()
	{
		if (!this.isPolicyInformationAvailable()) return "no-policy";
		if (this.isAccountInGoodStanding()) return "good";
		return "deficient";
	}

	getVehicleMake() //LMIT-919
	{
		var m = this.state.dbFields["useroem"];
		if (m !==undefined && (
			m.match(/Hyundai/i) ||
			m.match(/Vw/i)
		))
		{
			m = this.camelCase(this.state.dbFields["Make"]);
		} else {
			m = this.state.dbFields["LossPayee"];
		}
		if (m===undefined || m==="Null") m="";
		return m;
	}

	getClassForLogo() //LMIT-968
	{
		var v = "";
		var oem = this.state.dbFields["useroem"];
		if (oem !==undefined){
			if (oem.match(/sci/i))
			{
				v = 'sci';
			} else if (oem.match(/pfaff/i)){
				v = 'pfaff';
			}
		}
		if (v===""){
			v = (""+this.state.dbFields["Make"]).toLowerCase();
		}
		return v;
	}

	render() {
		let uploadLightbox;
		if (this.state.isActiveUploadLightbox) {
			uploadLightbox = < UploadLightbox fnDismiss={this.dismissUploadLightbox} useroem={this.state.dbFields["useroem"]} />;
		}
		//console.log("state: %o", this.state.dbFields);

		var accountStanding;
		switch(this.getClassForAccountInGoodStanding())
		{
			case "no-policy":
				accountStanding =	<div className="msg2">
										{ window.l10n[window.locale]["lessee.msg-no-policy"] }
									</div>
			break;

			case "good":
				accountStanding =	<div className="msg2">
										{ window.l10n[window.locale]["lessee.msgok"] }
									</div>
				break;

			case "deficient":
				accountStanding =	<span>
										<div className="msg1">
											{ window.l10n[window.locale]["lessee.pleaseupload"] }
										</div>
										<br/>
										<div className="msg2">
											{ window.l10n[window.locale]["lessee.caption3"] }
										</div>
									</span>;
				break;
			default:
		}

		return (
			<div id="lessee-page">
				<div className={"ajax-spinner-lightbox " + this.state.ajaxLoadingState } />
				<div className={"lessee-logo " + ("" + window.locale).toLowerCase() + " " + this.getClassForLogo()} />
				<div className="lessee-date" >{this.state.strDate}</div>
				<div className="lessee-frame">
					<div className="lessee-welcome">{ window.l10n[window.locale]["lessee.welcome"] }</div>
					<div className="lessee-full-name">{this.state.dbFields["FirstName"]} {this.state.dbFields["LastName"]}</div>
					<hr className="lessee-divider"/>
					<div className="lessee-review">
						{window.l10n[window.locale]["lessee.caption1"]}
						<span className="lessee-review-line2">
							{window.l10n[window.locale]["lessee.caption2"]}
						</span>
					</div>

					<div className="lessee-policy-container">
						<div className="lessee-policy-caption carrier">{window.l10n[window.locale]["lessee.carrier"]}</div>
						<div className="lessee-policy-caption policy">{window.l10n[window.locale]["lessee.policynumber"]}</div>
						<div className="lessee-policy-vertical-divider vd1" />
						<div className="lessee-policy-vertical-divider vd2" />

						<div className="lessee-policy carrier">{this.state.dbFields["InsuranceCompanyName"]}</div>
						<div className="lessee-policy policy">{this.state.dbFields["PolicyNumber"]}</div>

						<hr className="lessee-policy-divider"/>
						<div className="lessee-policy-caption account">
							{this.getVehicleMake()} {window.l10n[window.locale]["lessee.leaseaccountnumber"]}
						</div>
						<div className="lessee-policy-caption vehicle">
							{window.l10n[window.locale]["lessee.vehicledescription"]}
						</div>
						<div className="lessee-policy-caption vin">
							{window.l10n[window.locale]["lessee.vinnumber"]}
						</div>

						<div className="lessee-policy-value account">
							{this.state.dbFields["AccountNumber"]}
						</div>
						<div className="lessee-policy-vertical-divider vd3" />
						<div className="lessee-policy-vertical-divider vd4" />
						<div className="lessee-policy-value vehicle">
							{this.state.dbFields["VehicleDescription"]}
						</div>
						<div className="lessee-policy-value vin">
							{this.state.dbFields["VIN"]}
						</div>
					</div>

					<div className="lessee-coverage-container">
						<div className="lessee-coverage-review">
							<div className="line1">
								{window.l10n[window.locale]["lessee.requirements"]}
							</div>
							<div className="line2">
								 { window.l10n[window.locale]["lessee.requirements1"] }
							</div>
						</div>
						<div className="lessee-coverage-border" />
						<div className="lessee-coverage-details-caption">
							{window.l10n[window.locale]["lessee.currentcoverage"]}
						</div>

						<div className="lessee-coverage-vertical-divider" />
						<div className={"lessee-coverage-details " + (this.isPolicyInformationAvailable() ? "" : "no-policy" )}>
							<ul>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["ExpiredIssues"]) + "col1"}>{ window.l10n[window.locale]["lessee.policyexpires"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["ComprehensiveIssues"]) + "col2"}>{ window.l10n[window.locale]["lessee.comprehensiveded"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["TPLIssues"]) + "col1"}>{ window.l10n[window.locale]["lessee.thirdparty"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["PermToRentOrLeaseEndorsementIssues"]) + "col2"}>{ window.l10n[window.locale]["lessee.permissiontorent"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["AllPerilsIssues"] ) + "col1"}>{ window.l10n[window.locale]["lessee.allperils"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["AdditionalInsuredIssues"] ) + "col2"}>{this.state.dbFields["LossPayee"] + " " + window.l10n[window.locale]["lessee.additionalinsured"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["CollsionIssues"] ) + "col1"}>{ window.l10n[window.locale]["lessee.collisionded"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["LossPayeeIssues"] ) + "col2"}>{this.state.dbFields["LossPayee"] + " " + window.l10n[window.locale]["lessee.losspayee"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["CancelledIssues"] ) + "col1"}>{ window.l10n[window.locale]["lessee.policycancelled"] }</li>
							</ul>
						</div>
					</div>

					<div className="lessee-renews-container">
						<div className={ "lessee-renews-header " + this.getClassForAccountInGoodStanding()} >
							<ul>
								<li className={ this.getClassForAccountInGoodStanding() }>{ window.l10n[window.locale]["lessee.adequate"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["ExpiredIssues"]) + "col1"}>{ window.l10n[window.locale]["lessee.policyexpires"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["ComprehensiveIssues"]) + "col2"}>{ window.l10n[window.locale]["lessee.comprehensiveded"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["TPLIssues"]) + "col1"}>{ window.l10n[window.locale]["lessee.thirdparty"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["PermToRentOrLeaseEndorsementIssues"]) + "col2"}>{ window.l10n[window.locale]["lessee.permissiontorent"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["AllPerilsIssues"] ) + "col1"}>{ window.l10n[window.locale]["lessee.allperils"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["AdditionalInsuredIssues"] ) + "col2"}>{this.state.dbFields["LossPayee"] + " " + window.l10n[window.locale]["lessee.additionalinsured"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["CollsionIssues"] ) + "col1"}>{ window.l10n[window.locale]["lessee.collisionded"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["LossPayeeIssues"] ) + "col2"}>{this.state.dbFields["LossPayee"] + " " +  window.l10n[window.locale]["lessee.losspayee"] }</li>
								<li className={ this.getClassForPolicyItem(this.state.dbFields["CancelledIssues"] ) + "col1"}>{ window.l10n[window.locale]["lessee.policycancelled"] }</li>
							</ul>


						</div>

						<div className="caption2">
						{/*<div className="expiry-date">
								{this.state.dbFields["PolicyExpiryDate"]}
							</div>
						*/}
							<br/><br/>
							{accountStanding}
							<input
								className="upload-btn"
								type="button"
								value={window.l10n[window.locale]["lessee.uploadfiles"]}
								onClick={this.showUploadLightbox}
							/>
						</div>
					</div>
					{uploadLightbox}
				</div>
			</div>

		);
	}
}
export default DocumentUploadPage;



// WEBPACK FOOTER //
// ./src/components/lessee-page.js